function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.7319 1.17803C11.8734 1.31952 11.9441 1.39026 11.9743 1.47029C12.0086 1.56082 12.0086 1.66071 11.9743 1.75123C11.9441 1.83126 11.8734 1.90201 11.7319 2.0435L4.87318 8.90229C4.73169 9.04378 4.66095 9.11453 4.58092 9.14477C4.4904 9.17898 4.3905 9.17898 4.29998 9.14477C4.21995 9.11453 4.1492 9.04379 4.00771 8.90229L0.26813 5.16271C0.12664 5.02122 0.0558955 4.95048 0.0256538 4.87044C-0.00855126 4.77992 -0.00855127 4.68003 0.0256538 4.58951C0.0558955 4.50948 0.12664 4.43873 0.26813 4.29724L1.17804 3.38734C1.31953 3.24585 1.39027 3.1751 1.47031 3.14486C1.56083 3.11065 1.66072 3.11065 1.75124 3.14486C1.83127 3.1751 1.90202 3.24585 2.04351 3.38734L4.0077 5.35153C4.46344 5.80727 4.39335 5.83134 4.87317 5.35152L9.95648 0.268134C10.098 0.126643 10.1687 0.0558972 10.2487 0.0256549C10.3393 -0.00855088 10.4392 -0.00855164 10.5297 0.0256527C10.6097 0.0558938 10.6805 0.126638 10.822 0.268127L11.7319 1.17803Z",
  fill: "#333333"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 12,
    height: 10,
    viewBox: "0 0 12 10",
    fill: "none"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/CheckIcon.34175a1e.svg";
export { SvgComponent as ReactComponent };